import SiafLiteApiRepository from "../../external/siafLiteApi";

class ServicoPrecificacaoService {
  constructor() {
    this.urlBase = "/estoque/servico-precificacao";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  upsert(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/upsert`).post(body);
  }
}

export default ServicoPrecificacaoService;
